import React, { useState } from 'react';
import PageContainer from '../../components/layouts/PageContainer';
import BreadCrumb from '../../components/elements/BreadCrumb';
import HeaderMarketPlace from '../../components/shared/headers/HeaderMarketPlace';
import HeaderMobile from '../../components/shared/headers/HeaderMobile';
import FooterMarketPlace2 from '../../components/shared/footers/FooterMarketPlace2';
import { useRef } from 'react';
import { Helmet } from 'react-helmet';
import axios from 'axios';
import { notification } from 'antd';
import Loader from '../Loader';
import config from '../../config';

import JobListings from './JobList';

import careerImg from '../../assets/static/img/career.jpg';

const Career = () => {
  // useEffect(() => {
  //     if (
  //         !localStorage.getItem("auth_user")
  //     ) {
  //         navigate("/login");
  //     }
  // }, []);

  const breadCrumb = [
    {
      text: 'Home',
      url: '/',
    },
    {
      text: 'Recruitment',
    },
  ];

  const headers = (
    <>
      <HeaderMarketPlace />
      <HeaderMobile />
    </>
  );
  const footer = <FooterMarketPlace2 />;

  const formRef = useRef(null);
  const fileRef = useRef(null);

  const [name, setName] = useState('');
  const [email, setEmail] = useState('');
  const [phone, setPhone] = useState('');
  const [position, setPosition] = useState('');
  const [ctc, setCtc] = useState('');
  const [file, setFile] = useState('');
  const [description, setDescription] = useState('');

  const [isLoading, setLoading] = useState(false);

  const [errors, setErrors] = useState({});

  const validation = () => {
    const newErrors = {};

    // Name
    if (!name.trim()) {
      newErrors.name = 'Full Name is required';
    } else if (!/^[A-Za-z\s]+$/.test(name.trim())) {
      newErrors.name = 'Only alphabets and spaces are allowed';
    } else if (name.trim().length < 2) {
      newErrors.name = 'Name must be at least 2 characters';
    }

    // Email
    if (!email.trim()) {
      newErrors.email = 'Email is required';
    } else if (
      !/^[A-Za-z0-9._%+-]+@[A-Za-z0-9.-]+\.[A-Za-z]{2,}$/.test(email.trim())
    ) {
      newErrors.email = 'Please enter a valid email address';
    }

    // Phone
    if (!phone.trim()) {
      newErrors.phone = 'Phone Number is required';
    } else if (!/^\d+$/.test(phone)) {
      newErrors.phone = 'Only digits are allowed';
    } else if (phone.length < 10 || phone.length > 11) {
      newErrors.phone = 'Phone Number must be 10 or 11 digits';
    }

    // Position
    if (!position) {
      newErrors.position = 'Position is required';
    }

    // Desired Rate of Pay
    if (!ctc) {
      newErrors.ctc = 'Desired Rate of Pay is required';
    } else if (!/^\d+$/.test(ctc)) {
      newErrors.ctc = 'Only digits are allowed';
    } else if (ctc.length > 10) {
      newErrors.ctc = 'Maximum 10 digits allowed';
    }

    // Resume
    if (!file) {
      newErrors.file = 'Resume is required';
    }

    // Description
    if (!description.trim()) {
      newErrors.description = 'Tell us about yourself is required';
    }

    setErrors(newErrors);

    return Object.keys(newErrors).length === 0;
  };
  const onGetinTouch = async (e) => {
    e.preventDefault();
    if (validation()) {
      setLoading(true);
      const formData = new FormData();
      formData.append('name', name);
      formData.append('email', email);
      formData.append('phone', phone);
      formData.append('description', description);
      formData.append('position', position);
      formData.append('file', file);
      formData.append('ctc', ctc);
      try {
        const response = await axios({
          method: 'post',
          url: `${config.apiUrl}/add_career`,
          data: formData,
          headers: {
            Accept: 'application/json'
          },
        }).then((response) => {
          notification.open({
            message: (
              <div className="d-flex">
                <div className="pr-20">
                  <i className="fa fa-check" style={{ color: '#4bb543' }}></i>
                </div>
                <div>Thank you for visiting Whanson Group</div>
              </div>
            ),
            description: 'Our Team Will Contact You Soon',
          });
          setLoading(false);
          setName('');
          setPhone('');
          setEmail('');
          setCtc('');
          setPosition('');
          setDescription('');
          setFile('');
          fileRef.current.value = '';
        });
      } catch (error) {
        console.log(error);
        setLoading(false);
      }
    }
  };

  const positions = [
    'Sawmill Machine Operator',
    'Yard Worker',
    'Yardman',
    'HGV Class 2 HIAB Driver',
  ];

  function getValidationError(error) {
    return error ? (
      <span className="text-danger span-error">{error}</span>
    ) : null;
  }

  return (
    <div>
      {isLoading && <Loader />}
      <Helmet>
        <title>Explore Exciting Career Opportunities at W-Hanson UK</title>
        <meta
          name="description"
          Content="Discover rewarding job openings at W-Hanson UK. Join us in shaping the future of [industry/sector]. Apply today!"
        />
      </Helmet>
      <PageContainer header={headers} footer={footer} title="Register">
        <div className="ps-page--single">
          <img
            src={careerImg}
            height="300"
            style={{ width: '100%', objectFit: 'cover' }}
            loading="lazy"
            alt="companyImage"
          />
          <BreadCrumb breacrumb={breadCrumb} />
          <div className="ps-section--custom pb-0">
            <div className="container ">
              <h1
                className="text-center mb-5 display-4"
                style={{ fontWeight: '600' }}
              >
                Job Vacancies
              </h1>

              <JobListings formRef={formRef} setPosition={setPosition} />
            </div>

            <div className="container pt-60">
              <div className="row justify-content-center pb-70">
                <div className="col-10 text-center career-text mobile-career">
                  <h3 className="mb-5 display-4" style={{ fontWeight: '500' }}>
                    Examine Potential, Develop Your Career, Design Your
                    Professional Path, and Move Forward: Jobs at Whanson Group
                    For Career Opportunities
                  </h3>
                  <p>
                    As we embark on our journey towards innovation and
                    excellence, we invite passionate and talented individuals to
                    join our dynamic team, where collaboration, creativity, and
                    a commitment to making a positive impact converge to create
                    a workplace that fosters personal growth, professional
                    development, and the pursuit of shared goals, shaping not
                    only careers but a collective vision for a brighter and more
                    impactful future.
                  </p>

                  <div className="form-group submit mt-5" ref={formRef}>
                    <button
                      type="submit"
                      className="ps-btn ps-btn--fullwidth bg-blue color-white col-4 bd-join"
                      onClick={() =>
                        formRef?.current?.scrollIntoView({ behavior: 'smooth' })
                      }
                    >
                      Join Us Now
                    </button>
                  </div>
                </div>
              </div>
            </div>
            <div className="form-bg-blue">
              <div className="container">
                <div className=" row justify-content-center pt-50 pb-50">
                  <form
                    className="ps-form--contact-us col-md-9 career-form"
                    onSubmit={onGetinTouch}
                  >
                    <h3
                      className="text-center mb-5 display-4 pb-5"
                      style={{ fontWeight: '500' }}
                    >
                      Please complete the form below with your details
                    </h3>
                    <div className="row">
                      <div className="col-xl-6 col-lg-6 col-md-6 col-sm-12 col-12 mb-4 ">
                        <div className="form-group">
                          <label className="mb-3">
                            Full Name <span className="text-danger">*</span>
                          </label>
                          <input
                            className="form-control mb-0"
                            type="text"
                            placeholder="Enter Full Name "
                            value={name}
                            onChange={(e) => {
                              const value = e.target.value.replace(
                                /[^A-Za-z\s]/g,
                                ''
                              );
                              setName(value);

                              if (errors.name) {
                                setErrors({ ...errors, name: '' });
                              }
                            }}
                          />
                          {getValidationError(errors.name)}
                        </div>
                      </div>
                      <div className="col-xl-6 col-lg-6 col-md-6 col-sm-12 col-12 mb-4 ">
                        <div className="form-group">
                          <label className="mb-3">
                            Email Address <span className="text-danger">*</span>
                          </label>
                          <input
                            className="form-control mb-0"
                            type="email"
                            placeholder="Enter Email "
                            value={email}
                            onChange={(e) => {
                              setEmail(e.target.value.trim());

                              if (errors.email) {
                                setErrors({ ...errors, email: '' });
                              }
                            }}
                          />
                          {getValidationError(errors.email)}
                        </div>
                      </div>
                      <div className="col-xl-6 col-lg-6 col-md-6 col-sm-12 col-12 mb-4 ">
                        <div className="form-group">
                          <label className="mb-3">
                            Phone Number <span className="text-danger">*</span>
                          </label>
                          <input
                            className="form-control mb-0"
                            type="text"
                            inputMode="numeric"
                            placeholder="Enter Phone Number "
                            value={phone}
                            maxLength={15}
                            onChange={(e) => {
                              const value = e.target.value.replace(/\D/g, '');
                              setPhone(value);

                              if (errors.phone) {
                                setErrors({ ...errors, phone: '' });
                              }
                            }}
                          />
                          {getValidationError(errors.phone)}
                        </div>
                      </div>
                      <div className="col-xl-6 col-lg-6 col-md-6 col-sm-12 col-12 mb-4 ">
                        <div className="form-group">
                          <label className="mb-3">
                            Position <span className="text-danger">*</span>
                          </label>
                          <select
                            className="form-select form-control w-100 shadow-sm"
                            onChange={(e) => setPosition(e.target.value)}
                            value={position}
                          >
                            <option value="">Select Position</option>
                            {positions.map((pos) => (
                              <option key={pos} value={pos}>
                                {pos}
                              </option>
                            ))}
                          </select>
                          {getValidationError(errors.position)}
                          {/* <input
                                                        className="form-control mb-0"
                                                        type="text"
                                                        placeholder="Enter Position "
                                                        value={position}
                                                        onChange={(e) => setPosition(e.target.value)}
                                                    /> */}
                        </div>
                      </div>
                      <div className="col-xl-6 col-lg-6 col-md-6 col-sm-12 col-12 mb-4 ">
                        <div className="form-group">
                          <label className="mb-3">
                            Desired Rate of Pay{' '}
                            <span className="text-danger">*</span>
                          </label>
                          <input
                            className="form-control mb-0"
                            type="text"
                            placeholder="Enter Desired Rate of Pay "
                            value={ctc}
                            maxLength={10}
                            onChange={(e) =>
                              setCtc(e.target.value.replace(/\D/g, ''))
                            }
                          />
                          {getValidationError(errors.ctc)}
                        </div>
                      </div>
                      <div className="col-xl-6 col-lg-6 col-md-6 col-sm-12 col-12 mb-4 ">
                        <div className="form-group">
                          <label className="mb-3">
                            Upload Resume <span className="text-danger">*</span>
                          </label>
                          <input
                            className="form-control mb-0"
                            type="file"
                            style={{ paddingTop: '14px' }}
                            onChange={(e) => setFile(e.target.files[0])}
                            ref={fileRef}
                          />
                          {getValidationError(errors.file)}
                        </div>
                      </div>
                      <div className="col-xl-12 col-lg-12 col-md-12 col-sm-12 col-12 ">
                        <div className="form-group">
                          <label className="mb-3">
                            Tell us about yourself{' '}
                            <span className="text-danger">*</span>
                          </label>

                          <textarea
                            className="form-control mb-0"
                            rows="5"
                            placeholder="Tell us about yourself"
                            value={description}
                            onChange={(e) => {
                              setDescription(e.target.value);

                              if (errors.description) {
                                setErrors({ ...errors, description: '' });
                              }
                            }}
                          ></textarea>

                          {getValidationError(errors.description)}
                        </div>
                      </div>
                    </div>
                    <div className="form-group submit ">
                      <button className="ps-btn bg-blue color-white">
                        Apply Now
                      </button>
                    </div>
                  </form>
                </div>
              </div>
            </div>
          </div>
        </div>
      </PageContainer>
    </div>
  );
};

export default Career;
